import { useFeatureGate } from '@ctct/awesome-feature-flags';
import { envs, urlParams } from '@ctct/infrastructure-layer';

const isStripeScheduledDowngradeEnabledViaURLParam = urlParams.getIfStripeScheduledDowngradeTurnedOn();

export const useIsStripeScheduledDowngradeEnabled = () => {
  if (envs.isSecure()) {
    return {
      data: isStripeScheduledDowngradeEnabledViaURLParam,
      isLoading: false,
      isError: false,
      error: null,
    } as ReturnType<typeof useFeatureGate>;
  }

  // hooks list will be stable per env, so we can safely disable the hooks rule
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useFeatureGate({
    name: 'enable_stripe_scheduled_downgrade',
    defaultValue: isStripeScheduledDowngradeEnabledViaURLParam,
  });
};
